module.exports = __webpack_public_path__ + "static/img/blog_4.79bbba5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/blog/blog_4.jpg
// module id = WQ01
// module chunks = 1